<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb activeName="角色信息" :breadcrumbItem="[{to:'/system/rbac/role',name:'角色信息'}]"></breadcrumb>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      角色信息
      <small>角色信息...</small>
    </h1>
    <!-- end page-header -->
    <panel title="公司角色信息" :noButton="true">
      <div slot="heading-btn">
        <button type="button" class="btn btn-theme btn-sm" size="small" @click="edit_role(0,null)">
          <i class="fa fa-plus"></i> 新增角色
        </button>
      </div>

      <Table border :columns="columns" :data="roles">
        <template slot-scope="{ row }" slot="name">
          <strong>{{ row.name }}</strong>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-xs"
            style="margin-right: 5px"
            size="small"
            @click="assign_permission(row)"
          >分配权限</button>
          <button
            type="button"
            class="btn btn-theme btn-xs"
            v-if="row.id !==1"
            style="margin-right: 5px"
            @click="edit_role(1,row)"
          >修改</button>
          <button
            type="button"
            class="btn btn-danger btn-xs"
            style="margin-right: 5px"
            v-if="row.id !==1"
            @click="remove_role(index,row)"
          >删除</button>
        </template>
      </Table>
      <Drawer
        :title="edit_roledata.name"
        v-model="v_assign_permission"
        width="500"
        :mask-closable="true"
        :styles="styles"
      >
        <h5>角色: {{edit_roledata.name}}</h5>
        <Tree :data="permission_data" show-checkbox multiple ref="permisson_tree"></Tree>
        <div class="demo-drawer-footer">
          <button
            type="button"
            class="btn btn-default"
            style="margin-right: 8px"
            @click="v_assign_permission = false"
          >取消</button>
          <button type="button" class="btn btn-theme" @click="fn_save_role_permission">保存</button>
        </div>
      </Drawer>
    </panel>
  </div>
</template>
<script>
import {
  getRoleList,
  storeRole,
  removeRole,
  assignPermission
} from "@/api/system/role";
import breadcrumb from "@/components/breadcrumb";
import { getPermissionTree } from "@/api/system/permission";
import moment from "moment";
export default {
  components: { breadcrumb },
  beforeMount() {
    getRoleList()
      .then(res => {
        if (res.status === 200) {
          this.roles = res.data;
        }
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  data() {
    return {
      columns: [
        {
          title: "名称",
          slot: "name",
          width: 200
        },
        {
          title: "创建时间",
          key: "created_at",
          width: 200
        },
        {
          title: "操作",
          slot: "action",
          width: 300,
          align: "left"
        }
      ],
      edit_roledata: { name: "" },
      roles: [],
      v_assign_permission: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      permission_data: []
    };
  },
  methods: {
    edit_role(flag, data) {
      let rolename = "";
      let id = 0;
      if (flag === 1) {
        id = data.id;
        rolename = data.name;
      } else {
        id = 0;
      }

      let _this = this;
      this.$Modal.confirm({
        render: h => {
          return h("Input", {
            props: {
              value: rolename,
              autofocus: true,
              placeholder: "请输入角色名称..."
            },
            on: {
              input: val => {
                this.value = val;
              }
            }
          });
        },
        onOk: () => {
          storeRole(id, this.value)
            .then(res => {
              if (res.data.code === 200) {
                if (id > 0) {
                  this.$set(data, "name", this.value);
                  _this.v_assign_permission = false;
                } else {
                  this.roles.push({
                    id: res.data.id,
                    name: this.value,
                    created_at: moment().format("YYYY-MM-DD HH:mm:ss")
                  });
                }

                _this.$Notice.success({
                  title: "提示",
                  desc: res.data.message
                });
              } else {
                _this.$Notice.error({ title: "错误", desc: res.data.message });
              }
            })
            .catch(error => {
              _this.$Notice.error({ title: "错误", desc: error });
            });
        }
      });
    },
    remove_role(index, data) {
      //  删除角色 ， 必须是无用户挂靠，删除角色直接把对应的角色和权限的关系也一起删除

      let _this = this;
      this.$Modal.confirm({
        title: "确认要删除" + data.name + "吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function() {
          removeRole(data.id)
            .then(res => {
              if (res.data.code === 200) {
                _this.$Notice.success({
                  title: "提示",
                  desc: res.data.message
                });

                _this.roles.splice(index, 1);
              } else {
                _this.$Notice.error({
                  title: "提示",
                  desc: res.data.message
                });
              }
            })
            .catch(error => {
              _this.$Notice.error({
                title: "错误",
                desc: error
              });
            });
        }
      });
    },
    assign_permission(data) {
      this.edit_roledata = data;
      getPermissionTree(data.id)
        .then(res => {
          this.permission_data = res.data;
        })
        .catch(error => {
          this.$Message.error(error);
        });
      this.v_assign_permission = true;
    },
    fn_save_role_permission() {
      let data = this.$refs.permisson_tree.getCheckedNodes();
      //过滤掉公司的节点，部门的节点有corpid字段
      var ret_role_permission = [];
      data.forEach(element => {
        ret_role_permission.push(element.id);
      });
      ret_role_permission = JSON.stringify(ret_role_permission);
      assignPermission(this.edit_roledata.id, ret_role_permission)
        .then(res => {
          if (res.data.code === 200) {
            this.$Notice.success({
              title: "通知",
              desc: res.data.message
            });
          } else {
            $this.$Notice.error({
              title: "错误",
              desc: res.data.message
            });
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>
<style>
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>